/* eslint-disable import/prefer-default-export */
import { useState } from 'react'
import { useDeepCompareEffect } from 'react-use'

import { usePaginatedTestimonialsQuery } from '~generated/hooks'
import { TestimonialsFilterInput } from '~generated/types'
import useDebounce from '~lib/hooks/useDebounce'

interface UsePaginatedTestimonialsParams {
  filter: TestimonialsFilterInput
}

export function usePaginatedTestimonials({ filter }: UsePaginatedTestimonialsParams) {
  const [page, setPage] = useState(1)

  useDeepCompareEffect(() => {
    setPage(1)
  }, [filter])

  const {
    data: { paginatedTestimonials } = {},
    loading,
    called,
    variables,
  } = usePaginatedTestimonialsQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      filter,
      pagination: {
        page,
        limit: 10,
      },
    },
  })

  const loadPage = useDebounce(
    (nextPage: number) => {
      if (!loading && paginatedTestimonials?.totalPages >= nextPage) {
        setPage(nextPage)
      }
    },
    300,
    [loading, paginatedTestimonials?.totalPages]
  )

  return {
    paginatedTestimonials,
    page,
    variables,
    loadPage,
    loading,
    called,
  }
}
